// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3zQkK","consentsList":"PatientConsents_consentsList__uNR2o","consentsListEmpty":"PatientConsents_consentsListEmpty__1Ugl7"};